import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HttpModule} from '@angular/http';
import {SharedTranslationModule} from '../shared/change-language/shared-translation.module';
import {LayoutModule} from '../layout/layout.module';
import {AutoCompleteModule, DialogModule} from 'primeng/primeng';
import {EmrsidebarComponent} from './emrsidebar.component';
import {SafeUrlModule} from '../shared/custom-pipe/safe-url.module';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {NgxBarcodeModule} from 'ngx-barcode';
import {CollapseModule, ModalModule} from 'ngx-bootstrap';
import {routing} from './emrsidebar.routing';
import { EmrCasePaperComponent } from './emr-case-paper/emr-case-paper.component';
import {EmrCasePaperModule} from './emr-case-paper/emr-case-paper.module';

@NgModule({
    imports: [
        CommonModule,
        routing,
        FormsModule,
        ReactiveFormsModule,
        NgxBarcodeModule,
        DialogModule,
        SafeUrlModule,
        HttpModule,
        SharedTranslationModule,
        AutoCompleteModule,
        BrowserAnimationsModule,
        LayoutModule,
        CollapseModule.forRoot(),
        ModalModule.forRoot(),
        EmrCasePaperModule
    ],
    declarations: [EmrsidebarComponent],
    providers: []
})
export class EmrsidebarModule {
}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/emrsidebar/emrsidebar.module.ts